import { render, staticRenderFns } from "./DetailFinanceur.vue?vue&type=template&id=5040007b&scoped=true"
import script from "./DetailFinanceur.vue?vue&type=script&lang=js"
export * from "./DetailFinanceur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040007b",
  null
  
)

export default component.exports